import { useNavigate } from "react-router-dom";
import type { CountryLite } from "@shared/types";
import { api } from "../lib/api";
import { useAsync } from "../lib/useAsync";
import { useNation } from "../lib/useNation";
import { Modal } from "./Modal";
import { CountryPickList } from "./CountryPickList";
import { useT } from "../i18n";

// Pick (or change) your home nation. Persists the choice and jumps to that
// country's page. Opened from the nav chip's ⇄ button.
export function NationSwitcher({ onClose }: { onClose: () => void }) {
  const t = useT();
  const nav = useNavigate();
  const { setNation } = useNation();
  const { data, loading, error } = useAsync(() => api.countries(), []);

  const pick = (c: CountryLite) => {
    setNation(c);
    onClose();
    nav(`/c/${c.id}`);
  };

  return (
    <Modal title={t("nation.choose")} onClose={onClose}>
      <CountryPickList countries={data} loading={loading} error={error} onPick={pick} />
    </Modal>
  );
}
